import { memo } from 'react';
import { OButton } from '@src/shared';
import { useRejoin } from '@src/hooks';
import HomeLogo from '@src/assets/images/home/home.png';

import './rejoin.scss';
import { useLocation } from 'react-router-dom';

const Rejoin = () => {
  const { timeLeft, isMobileDevice, handleReturnHome, handleRejoin } = useRejoin();
  const location = useLocation();

  const roomType = location.state?.roomType || 'meeting';

  return (
    <div className="rejoin-container">
      <div className="rejoin-content-container">
        <img src={HomeLogo} alt="Home Logo" />
        <div className="text-container">
          <p className="text-container-header">{`You left the ${roomType}`}</p>
          <p className="text-container-content">You can rejoin at any time again within the meeting time</p>
        </div>
        <div className="button-container">
          <OButton
            text="Return to home screen"
            onClick={handleReturnHome}
            size={isMobileDevice ? 'medium' : 'x-medium'}
          />
          <OButton text="Rejoin" onClick={handleRejoin} outlined={true} size={isMobileDevice ? 'medium' : 'x-medium'} />
        </div>
        <div className="timer-container">
          <p className="timer-container-text">You'll be returning to the home screen within {timeLeft}'s</p>
        </div>
      </div>
      <div className="footer-container">
        <p className="footer-container-text" onClick={handleReturnHome}>
          Learn more about Meet
        </p>
      </div>
    </div>
  );
};

export default memo(Rejoin);
